// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false
};


export var config = {
    apiKey: "AIzaSyCMdHoPLKjVoOLCZR-ikitdkCfILeTnXnc",
    authDomain: "emenu-8dd61.firebaseapp.com",
    databaseURL: "https://emenu-8dd61.firebaseio.com",
    projectId: "emenu-8dd61",
    storageBucket: "emenu-8dd61.appspot.com",
    messagingSenderId: "415111130192"
  };
